const WorkspaceType = {
    OpenVPN:0,
    ConfigurationPackage:1,
    Software:2
}

const RemoteFileTreeType = {
    Software:0,
    Configuration:1
}

export {WorkspaceType, RemoteFileTreeType};